export const AISuggestedSkills = {
    Disprz_Skills: 0,
    Non_Disprz_Skills: 1
}